import React from 'react';
import styled from 'styled-components';
import { TextHeader } from './MainStyledComponents';
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';

const HeaderButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const ArrowWrap = styled.span<{ $asc: boolean; $active: boolean }>`
  display: inline-flex;
  transform: rotate(${({ $asc }) => ($asc ? '180deg' : '0deg')});
  opacity: ${({ $active }) => ($active ? 1 : 0.3)};
  transition: transform 0.15s ease;
`;

export type SortableHeaderProps = {
  label: string;
  active: boolean;
  direction: 'asc' | 'desc';
  onToggle: () => void;
};

export const SortableHeader = ({
  label,
  active,
  direction,
  onToggle,
}: SortableHeaderProps) => (
  <HeaderButton type="button" onClick={onToggle}>
    <TextHeader size={'XS'} colorText={'greyDark'} component={'span'}>
      {label}
    </TextHeader>
    <ArrowWrap
      $asc={active && direction === 'asc'}
      $active={active}
      aria-hidden="true"
    >
      <ArrowBottom />
    </ArrowWrap>
  </HeaderButton>
);
